import React from 'react'
import firebase from 'firebase'
import PanelWithContent from '../../../common/PanelWithContent/PanelWithContent'

export default class Test extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      data: undefined
    }
    this.renderContent = this.renderContent.bind(this)
  }
  componentWillMount () {
    const rootRef = firebase.database().ref()
    const config = rootRef.child('riso').child('configuration')
    config.on('value', dataSnapshot => {
      this.setState({
        data: dataSnapshot.child('fluor').val()
      })
    })
  }

  renderContent () {
    if (this.state.data) {
      return Object.keys(this.state.data).map(key => {
        return <div className={'container'}>
          <PanelWithContent
            saveData={() => {}}
            title={this.state.data[key].title}
            extraFieldContent={this.state.data[key].extraFieldContent}
            fields={this.state.data[key].fields}
            extraFieldEnabled={this.state.data[key].isExtraFieldEnabled} />
        </div>
      })
    } else {
      return <div>Loading</div>
    }
  }

  render () {
    return <div>
      {this.renderContent()}
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/general/App/Test/Test.js